module.exports = __webpack_public_path__ + "be533ae7dff166d762befa330fa2bce2.woff";